import React, { FC } from 'react'
import Button from '../atoms/Button/ButtonV2'
import IconChevronDownXs from '../icons/IconChevronDownXs/IconChevronDownXs'

type onLoadMoreClick = () => void

export interface ShowMoreButtonProps {
  onClick: onLoadMoreClick
  shouldLoadMore?: boolean
  browseLink?: string
}

const ShowMoreButton: FC<ShowMoreButtonProps> = ({
  onClick,
  shouldLoadMore,
  browseLink
}) => {
  return (
    <div className="flex items-center justify-center">
      <div className="hidden h-1 grow border-t border-gray-300 md:block lg:min-w-[300px]"></div>
      {shouldLoadMore && browseLink ? (
        <Button
          type="tertiary"
          aria-label="Show More Centers"
          as="a"
          href={browseLink}
          className="w-full md:w-auto"
        >
          Load More
        </Button>
      ) : (
        <Button
          type="tertiary"
          aria-label="Show More Centers"
          onClick={onClick}
          className="w-full md:w-auto"
        >
          More Centers
          <IconChevronDownXs
            strokeWidth="0.2"
            className="text-gray-900"
          />
        </Button>
      )}
      <div className="hidden h-1 grow border-t border-gray-300 md:block lg:min-w-[300px]"></div>
    </div>
  )
}

export default ShowMoreButton
